<template>
	<PageContainer size="s">
		<AmeliproCard
			card-title="Identification"
			class="pa-6 pb-6"
		>
			<VForm ref="form">
				<AmeliproTextField
					id="login"
					v-model="login"
					:rules="loginRules"
					required
					aria-required
					class="text-no-wrap"
					clearable
					label="Identifiant"
					placeholder="Identifiant"
					validate-on-blur
					@keyup.enter="submitLogin"
				/>
				<AmeliproTextField
					id="passworduser"
					v-model="passworduser"
					:rules="passwordRules"
					required
					aria-required
					class="text-no-wrap"
					label="Mot de passe"
					placeholder="Mot de passe"
					:type="typeChamp"
					validate-on-blur
					@keyup.enter="submitLogin"
				>
					<template #append>
						<AmeliproIconBtn
							id="displayPassword"
							btn-label="displayPassword"
							icon-bg-color="ap-white"
							icon-color="ap-blue darken-1"
							icon-hover-bg-color="ap-blue darken-2"
							icon-hover-color="ap-white"
							icon="oeil"
							large
							@click="togglePasswordVisibility"
						/>
					</template>
				</AmeliproTextField>

				<div class="d-flex flex-column flex-sm-row justify-sm-space-between">
					<div class="text-right small-spacer mt-n2 mb-4">
						<a
							class="v-link"
							href="/forgot-password"
						>Mot de passe oublié </a>
					</div>

					<AmeliproBtn @click="submitLogin">
						Vous connecter
					</AmeliproBtn>
				</div>
			</VForm>
		</AmeliproCard>
	</PageContainer>
</template>

<script lang="ts">
	import Component, { mixins } from 'vue-class-component';

	import { required } from '@cnamts/vue-dot/src/rules/required';
	import { minLength } from '@cnamts/vue-dot/src/rules/minLength';
	import { Refs, VForm } from '@cnamts/vue-dot/src/types';
	import UserMixin from '@/mixins/userMixin';
	const MixinsDeclaration = mixins(UserMixin);
	import AuthService from '@/services/auth';

	@Component({})
	export default class LoginForm extends MixinsDeclaration {
		$refs!: Refs<{
			form: VForm;
		}>;

		// Les options du composant sont celles des propriétés de classe
		login = '';
		passworduser = '';
		showPassword = false;
		typeChamp = 'password';

		// Règles de validation
		loginRules = [required, minLength(6)];
		passwordRules = [required];

		togglePasswordVisibility(): void {
			this.showPassword = !this.showPassword;
			this.typeChamp = this.showPassword ? 'text' : 'password';
		}

		async submitLogin(): Promise<void> {
			await this.$nextTick(); // attend la mise à jour du cycle de vie
			if (this.$refs.form.validate()) {
				const errorMessage =
					'Erreur lors de la connexion, veuillez vérifier vos identifiants';
				try {
					// Validation réussie, vérifie des informations d'identification
					let authenticationResult = await AuthService.checkIdentifiants(
						this.login.trim(),
						this.passworduser
					);
					// Si l'authentification est réussie, enregistre les informations d'authentification et redirige vers la page d'accueil
					if (true === authenticationResult) {
						await this.$store.dispatch('authentication/storeAuthentication');
						await this.$store.dispatch('authentication/storeUserInformation');

						if (this.$store.getters['authentication/isLoggedIn']) {
							this.$router.push('/gardes/dpa');
						}
					} else {
						if (false === authenticationResult) {
							authenticationResult = errorMessage;
						}
						this.$store.dispatch('notification/add', {
							type: 'error',
							message: authenticationResult
						});
					}
				} catch (error) {
					this.$store.dispatch('notification/add', {
						type: 'error',
						message: errorMessage
					});
				}
			}
		}
	}
</script>
